import { message } from 'antd';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseuri from '../../baseuri';

export const getUserProfileById = createAsyncThunk(
	'userProfile/getUserProfileById',
	async (userId: any) => {
		const res = await baseuri.get('/admin/users/profile', {
			params: { userId },
		});

		return res.data.data;
	}
);

export const getUserWalletBalance = createAsyncThunk(
	'userProfile/getUserWalletBalance',
	async (userId: any) => {
		const res = await baseuri.get('/admin/wallets/user-wallet-balance', {
			params: { userId },
		});
		return res.data.data;
	}
);

export const getUserWalletBalanceNonRedux = async (userId: any) => {
	try {
		const res = await baseuri.get('/admin/wallets/user-wallet-balance', {
			params: { userId },
		});

		return res.data.data;
	} catch (e) {
		return null;
	}
};

export const getUserReferralOverview = createAsyncThunk(
	'userProfile/getUserReferralOverview',
	async (params: any) => {
		const res = await baseuri.get('/admin/users/referral-info', {
			params,
		});
		return res.data.data;
	}
);

export const unbindTelegramId = createAsyncThunk(
	'userProfile/unbindTelegramId',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/users/unbind-telegram-id', data);
			message.success('Telegram id removed successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const deactivatePhone = createAsyncThunk(
	'userProfile/deactivatePhone',
	async (data: any) => {
		try {
			const res = await baseuri.put(
				'/admin/users/deactivate-phone-verification',
				data
			);
			console.info('res', res);
			message.success('Phone verification deactivate successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const getUserWallets = createAsyncThunk(
	'userProfile/getUserWallets',
	async () => {
		const res = await baseuri.get('/user/wallets');
		return res.data.data;
	}
);

const userProfileRx = createSlice({
	name: 'userProfile',
	initialState: {
		user: {
			nextOfKin: {},
			paymentMethods: [],
			lastDeviceLogin: [
				{
					userDevice: {
						type: '',
						build: '',
						description: '',
						serial: '',
						deviceCountry: '',
						cfIpCountry: '',
						clientIP: '',
					},
					locationCoordinates: { lat: 0, long: 0 },
				},
			],
			profile: {
				_id: '',
				username: '',
				refereeName: null,
				hasCompletedProfile: false,
				deactivated: false,
				useInvestment: false,
				profileUrl: '',
				fullName: '',
				email: '',
				lastLogin: '',
				phoneNo: '',
				phoneNumber: null,
				isVerifiedPhone: false,
				livenessChecked: false,
				telegramId: '',
				countryCode: '',
				createdAt: '',
				updatedAt: '',
				googleId: null,
				appleId: null,
				twoFaResetTime: null,
				isRobot: false,
				ghostUserMerchantId: '',
				enabledTwoFactor: false,
				kycLevelTwoStatus: '',
				kycLevelThreeStatus: '',
				adminLastComment: '',
				trustScore: 0,
				riseVestInvestorId: '',
				investmentSignUpDate: '',
				allowInvestments: false,
				blockchainWalletMemo: '',
				bikandaProxyDetail: {
					email: '',
					mid: '',
				},
				registrationCoordinates: {
					long: '',
					lat: '',
				},
				registrationDeviceDetails: {
					cfIpCountry: '',
					serial: '',
					deviceCountry: '',
					xRealIp: '',
					description: '',
					build: '',
					type: '',
				},
				investorProfile: {
					accountEmail: '',
					accountType: '',
					customerId: '',
					email: '',
					firstName: '',
					isVirtual: '',
					lastName: '',
					status: '',
				},
				sumSubData: {
					country: '',
					dob: '',
					firstName: '',
					firstNameEn: '',
					idDocs: [],
					lastName: '',
					lastNameEn: '',
				},
				sumSubToken: '',
				kycAidData: {
					form_id: '',
					form_url: '',
					verification_url: '',
					form_token: '',
					verification_id: '',
					verification_attempts_left: null,
				},
				kycAidApplicantId: '',
			},
			loading: false,
			userActivities: {
				lastLoginLocation: {
					deviceCountry: '',
					cfIpCountry: '',
					xRealIp: '',
					deviceType: '',
					locationCoordinates: {
						lat: '',
						long: '',
					},
					userDevice: {
						description: '',
						serial: '',
						build: '',
					},
				},
			},
			transactionsCount: {
				transactions: 0,
				inappTransfers: 0,
				deposits: 0,
				withdrawals: 0,
				swap: 0,
				staking: 0,
			},
		},
		walletBalance: {
			walletAddress: '',
			cryptoBalances: [],
			fiatBalances: [],
			virtualDepositAccounts: [],
		},
		referralOverview: {
			totalReferrals: 0,
			unverified: 0,
			numOfUniqueDeviceIds: 0,
		},
		userWallets: {
			blockchainWalletMemo: '',
			cryptoBalances: [],
			cryptoBalancesUsdValue: 0,
			fiatBalances: [],
			fiatBalancesUsdValue: 0,
			tonWalletAddress: '',
			tonWalletAddressHex: '',
			virtualDepositAccounts: [],
			walletAddress: null,
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(getUserProfileById.fulfilled, (store, action) => {
				const state = store;
				state.user = { ...state.user, ...action.payload };
			})
			.addCase(getUserWalletBalance.fulfilled, (store, action) => {
				const state = store;
				state.walletBalance = action.payload;
			})
			.addCase(getUserReferralOverview.fulfilled, (store, action) => {
				const state = store;
				state.referralOverview = action.payload;
			})
			.addCase(getUserWallets.fulfilled, (store, action) => {
				const state = store;
				state.userWallets = action.payload;
			}),
});

export default userProfileRx.reducer;
